import { createElement } from 'react';
import { Input } from '@alifd/next';
import './index.scss';
const OadpInput = function OadpInput({ name, label, required, placeholder, defaultValue, disabled, ...otherProps }) {
    return (createElement(Input, Object.assign({ name: name, label: label, placeholder: placeholder, defaultValue: defaultValue, required: required, disabled: disabled, width: 100, hasClear: true, trim: true }, otherProps)));
};
export default OadpInput;
